import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default [
  '$timeout',
  function CUIModalDirective($timeout) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        toggle: '=',
        confirmState: '=?',
        confirmDisabled: '=?',
        cancelHandler: '&',
        confirmHandler: '&',
        modalTitle: '@',
        confirmText: '@',
        cancelText: '@',
        type: '@',
        confirmFormId: '@' //id of form that wires to the submit button (needed since the submit is outside of the form element)
      },
      template: require('./modal.jade')(jadeLocals),
      link: (scope, el, attrs) => {
        let cancelTypes = ['form', 'account', 'contact', 'confirm'],
          focusableElements, firstElement, lastElement,
          close = () => {
            if (attrs.cancelHandler) scope.cancelHandler();
            else {
              scope.toggle = false;
              scope.$emit('cui-modal-close');
            }
          },
          handleEscapePressed = e => {
            if (e.keyCode == 27) {
              close();
              scope.$applyAsync();
            }
          };

        scope.close = close;
        scope.confirm = attrs.confirmHandler ? scope.confirmHandler : scope.close;
        scope.confirmText = scope.confirmText || 'OK';
        scope.cancelText = scope.cancelText || 'CLOSE';
        scope.showCancel = scope.type ? (cancelTypes.indexOf(scope.type) > -1 ? true : false) : false;

        scope.backdropStyle = () => {
          return scope.toggle ? {
            'display': 'block'
          } : {
            'display': 'none'
          };
        };

        scope.$watch('toggle', visible => {
          if (visible) {
            focusableElements = $(el).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            firstElement = focusableElements.first();
            lastElement = focusableElements.last();

            firstElement.focus();

            console.log('bind it')
            $(document.body).on('keydown', handleEscapePressed);

            firstElement.on('keydown', function(e) {
              if (e.keyCode == 9 && e.shiftKey) {
                e.preventDefault();

                lastElement.focus();
              }
            });

            lastElement.on('keydown', function(e) {
              if (e.keyCode == 9 && !e.shiftKey) {
                e.preventDefault();

                firstElement.focus();
              }
            });

            if (cancelTypes.indexOf(scope.type) === -1) {
              $timeout(() => {
                el.find('.form-btn')[0].focus();
              });
            }
          } else {
            $(document.body).off('keydown', handleEscapePressed);
          }
        });

        scope.$on('$destroy', function() {
          if (firstElement.length) firstElement.off();
          if (lastElement.length) lastElement.off();
          $(document.body).off('keydown', handleEscapePressed);
        });
      }
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/modal/modal.dir.js